// Updated Layout Code Drop Down Master and Templetes
import { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  LayoutDashboard,
  Building2,
  Users,
  Package,
  FileText,
  Shield,
  History,
  Activity,
  LogOut,
  Scale,
  ChevronRight,
  SlidersHorizontal,
  Volume2,
  VolumeX,
  Menu,
  ScanLine,
  LayoutTemplate, //ajay:code 25-07-26
  ClipboardCheck, //ajay:code 30-07-26
  Settings, // ajay:code 22-08-26
  Sun, //ajay:code 10-09-26
  Moon, //ajay:code-10-09-26
} from "lucide-react";
import useBuzzer from "../../hooks/useBuzzer";
import { useTheme } from "../../context/ThemeContext"; //ajay:code 10-09-26
// import { clearUnlock } from "../PasswordGate"; // ajay:code 11-08-26

const NAV = {
  superadmin: [
    { to: "/superadmin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { to: "/superadmin/companies", icon: Building2, label: "Companies" },
    { to: "/superadmin/clients", icon: Users, label: "Clients" },
    { to: "/superadmin/client-users", icon: Users, label: "Client Users" },
  ],
  company: [
    { to: "/company/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { to: "/company/weight-history", icon: FileText, label: "Weight History" },

    {
      label: "Masters",
      icon: Package,
      children: [
        {
          to: "/company/masters",
          icon: Package,
          label: "Part Master",
        },
        {
          to: "/company/pdir-master",
          icon: Package,
          label: "PDIR Master",
        },
        {
          to: "/company/fpir-master",
          icon: Package,
          label: "FPIR Master",
        },
      ],
    },

    {
      label: "Templates",
      icon: LayoutTemplate,
      children: [
        // ajay:code 24-07-26
        {
          to: "/company/templates",
          icon: LayoutTemplate,
          label: "SPC Template",
        },
        //ajay:code 30-07-26
        {
          to: "/company/pdir",
          icon: ClipboardCheck,
          label: "PDIR Template",
        },
        {
          to: "/company/fpir",
          icon: ClipboardCheck,
          label: "FPIR Template",
        },
        // pfmea ajay:code 19-08-26
        {
          to: "/company/pfmea",
          icon: ClipboardCheck,
          label: "PFMEA Template",
        },
        // controlPlan ajay:code 27-08-26
        {
          to: "/company/control-plan",
          icon: ClipboardCheck,
          label: "Control Plan",
        },
      ],
    },
    { to: "/company/client-users", icon: Users, label: "Client Users" },
    { to: "/company/users", icon: Users, label: "Company Users" },
    { to: "/company/settings", icon: Settings, label: "Company Settings" }, // ajay:code 22-08-26
  ],
  client: [
    { to: "/client/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { to: "/client/history", icon: History, label: "Weight History" },
    { to: "/client/pdir", icon: ClipboardCheck, label: "PDIR Reports" }, // ajay:code 30-07-26
    { to: "/client/fpir", icon: ClipboardCheck, label: "FPIR Reports" },
    { to: "/client/pfmea", icon: ClipboardCheck, label: "PFMEA Reports" }, // ajay:code 19-08-26
    { to: "/client/control-plan", icon: ClipboardCheck, label: "Control Plan" }, // ajay:code 27-08-26
  ],
};

const ROLE_LABEL = {
  superadmin: "Super Admin",
  company: "Company Admin",
  client: "Client User",
};
const ROLE_COLOR = {
  superadmin: "var(--accent2)",
  company: "var(--accent)",
  client: "var(--success)",
};

export default function Layout({ role }) {
  // const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const links = NAV[role] || [];
  const { soundEnabled, toggleSound } = useBuzzer();
  const { theme, toggleTheme } = useTheme(); // ajay:code 10-09-26
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [logoPreview, setLogoPreview] = useState(false);
  // ajay:code 30-07-26
  const [mastersOpen, setMastersOpen] = useState(
    location.pathname.startsWith("/company/masters") ||
      location.pathname.startsWith("/company/pdir-master") ||
      location.pathname.startsWith("/company/fpir-master"),
  );
  const [templatesOpen, setTemplatesOpen] = useState(
    location.pathname.startsWith("/company/templates") ||
      (location.pathname.startsWith("/company/pdir") &&
        !location.pathname.startsWith("/company/pdir-master")) ||
      (location.pathname.startsWith("/company/fpir") &&
        !location.pathname.startsWith("/company/fpir-master")) ||
      location.pathname.startsWith("/company/pfmea") || // ajay:code 19-08-26
      location.pathname.startsWith("/company/control-plan"), // ajay:code 27-08-26
  );

  const { user, logout, companies, activeCompany, switchCompany } = useAuth(); //ajay:code 11-08-26

  // ajay:code 11-08-26
  // Client-only: reset the password-gate unlock whenever they land on an
  // UNPROTECTED page — per the confirmed rule ("unprotected page pe gaya to reset").
  const PAGE_KEY_MAP = [
    { prefix: "/client/dashboard", key: "dashboard" },
    { prefix: "/client/history", key: "weight_history" },
    { prefix: "/client/pdir", key: "pdir" },
    { prefix: "/client/fpir", key: "fpir" },
    { prefix: "/client/pfmea", key: "pfmea" }, // ajay:code 19-08-26
    { prefix: "/client/control-plan", key: "control-plan" }, //ajay:code 27-08-26
  ];
  // useEffect(() => {
  //   if (role !== "client" || !activeCompany) return;
  //   const match = PAGE_KEY_MAP.find((p) =>
  //     location.pathname.startsWith(p.prefix),
  //   );
  //   const currentKey = match?.key;
  //   const isProtected = (activeCompany.protected_pages || []).includes(
  //     currentKey,
  //   );
  //   if (!isProtected) {
  //     clearUnlock(activeCompany.company_id);
  //   }
  // }, [location.pathname, role, activeCompany]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* ── Sidebar ── */}
      <aside
        className={`sidebar ${sidebarOpen ? "open" : ""}`}
        style={{
          width: 220,
          minWidth: 220,
          background: "var(--surface)",
          borderRight: "1px solid var(--border)",
          display: "flex",
          flexDirection: "column",
          padding: "0",
        }}
      >
        {/* Logo */}
        <div
          style={{
            padding: "4px 4px 8px",
            borderBottom: "1px solid var(--border)",
          }}
        >
          <div style={{ display: "grid", alignItems: "center", gap: 8 }}>
            <div
              style={{
                width: 200,
                height: 100,
                borderRadius: 8,
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <img
                src="/image1.png"
                alt="WeightQA"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </div>
          </div>
        </div>

        {/* Role badge */}
        <div
          style={{
            padding: "12px 20px",
            borderBottom: "1px solid var(--border)",
          }}
        >
          <span
            style={{
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: ROLE_COLOR[role],
              padding: "3px 8px",
              background: `${ROLE_COLOR[role]}18`,
              borderRadius: 20,
            }}
          >
            {ROLE_LABEL[role]}
          </span>
        </div>

        {/* ajay:code 11-08-26 */}
        {/* {role === "client" && companies.length > 0 && (
          <div
            style={{
              padding: "10px 20px",
              borderBottom: "1px solid var(--border)",
            }}
          >
            <label
              style={{
                fontSize: 10,
                color: "var(--text3)",
                display: "block",
                marginBottom: 4,
              }}
            >
              Company
            </label>
            <select
              value={activeCompany?.company_id || ""}
              onChange={(e) => switchCompany(e.target.value)} */}
        {role === "client" &&
          companies.length > 0 &&
          location.pathname.startsWith("/client/dashboard") && (
            <div
              style={{
                padding: "10px 20px",
                borderBottom: "1px solid var(--border)",
              }}
            >
              <label
                style={{
                  fontSize: 10,
                  color: "var(--text3)",
                  display: "block",
                  marginBottom: 4,
                }}
              >
                Company
              </label>
              <select
                value={activeCompany?.company_id || ""}
                onChange={(e) => switchCompany(e.target.value)}
                style={{
                  width: "100%",
                  padding: "6px 8px",
                  borderRadius: 6,
                  fontSize: 12,
                  background: "var(--surface2)",
                  border: "1px solid var(--border2)",
                  color: "var(--text)",
                }}
              >
                {companies.map((c) => (
                  <option key={c.company_id} value={c.company_id}>
                    {c.company_name}
                  </option>
                ))}
              </select>
            </div>
          )}

        {/* Nav links */}
        {/* ajay:code 30-07-26 */}
        <nav style={{ flex: 1, padding: "10px 12px", overflow: "auto" }}>
          {links.map((item) => {
            // Dropdown Menu
            if (item.children) {
              const Icon = item.icon;

              const isMasters = item.label === "Masters";
              const isTemplates = item.label === "Templates";

              const isOpen = isMasters ? mastersOpen : templatesOpen;

              return (
                <div key={item.label}>
                  <div
                    onClick={() => {
                      if (isMasters) {
                        setMastersOpen(!mastersOpen);
                      }

                      if (isTemplates) {
                        setTemplatesOpen(!templatesOpen);
                      }
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      padding: "9px 10px",
                      borderRadius: "var(--radius)",
                      marginBottom: 2,
                      cursor: "pointer",
                      color: "var(--text2)",
                      fontWeight: 400,
                      fontSize: 13,
                      transition: "all 0.12s",
                    }}
                  >
                    <Icon size={15} />
                    <span style={{ flex: 1 }}>{item.label}</span>

                    <ChevronRight
                      size={12}
                      style={{
                        transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
                        transition: "0.2s",
                      }}
                    />
                  </div>

                  {isOpen &&
                    item.children.map((child) => {
                      const ChildIcon = child.icon;

                      return (
                        <NavLink
                          key={child.to}
                          to={child.to}
                          style={{ textDecoration: "none" }}
                          onClick={() => setSidebarOpen(false)}
                        >
                          {({ isActive }) => (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                padding: "9px 10px 9px 28px",
                                borderRadius: "var(--radius)",
                                marginBottom: 2,
                                background: isActive
                                  ? "var(--accent-dim)"
                                  : "transparent",
                                color: isActive
                                  ? "var(--accent)"
                                  : "var(--text2)",
                                fontWeight: isActive ? 600 : 400,
                                fontSize: 13,
                                transition: "all 0.12s",
                              }}
                            >
                              <ChildIcon size={15} />
                              <span style={{ flex: 1 }}>{child.label}</span>
                              {isActive && <ChevronRight size={12} />}
                            </div>
                          )}
                        </NavLink>
                      );
                    })}
                </div>
              );
            }

            // Normal Menu
            const Icon = item.icon;

            return (
              <NavLink
                key={item.to}
                to={item.to}
                style={{ textDecoration: "none" }}
                onClick={() => setSidebarOpen(false)}
              >
                {({ isActive }) => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      padding: "9px 10px",
                      borderRadius: "var(--radius)",
                      marginBottom: 2,
                      background: isActive
                        ? "var(--accent-dim)"
                        : "transparent",
                      color: isActive ? "var(--accent)" : "var(--text2)",
                      fontWeight: isActive ? 600 : 400,
                      fontSize: 13,
                      transition: "all 0.12s",
                    }}
                  >
                    <Icon size={15} />
                    <span style={{ flex: 1 }}>{item.label}</span>
                    {isActive && <ChevronRight size={12} />}
                  </div>
                )}
              </NavLink>
            );
          })}
        </nav>

        {/* ajay:code 10-09-26 */}
        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          role="switch"
          aria-checked={theme === "light"}
          title={
            theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"
          }
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            width: "100%",
            padding: "10px 14px",
            background: "transparent",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            color: "var(--text2)",
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          {theme === "dark" ? <Moon size={18} /> : <Sun size={18} />}

          <span style={{ flex: 1, textAlign: "left" }}>
            {theme === "dark" ? "Dark Mode" : "Light Mode"}
          </span>

          <div
            style={{
              width: 36,
              height: 20,
              borderRadius: 999,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              position: "relative",
            }}
          >
            <div
              style={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                background: theme === "dark" ? "var(--accent)" : "var(--warn)",
                position: "absolute",
                top: 1,
                left: theme === "dark" ? 18 : 1,
                transition: "left 0.2s ease",
              }}
            />
          </div>
        </button>

        {/* Sound toggle */}
        <button
          onClick={toggleSound}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            width: "100%",
            padding: "10px 14px",
            background: "transparent",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            color: soundEnabled ? "var(--accent)" : "#888",
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          {soundEnabled ? <Volume2 size={18} /> : <VolumeX size={18} />}
          {soundEnabled ? "Sound: ON" : "Sound: OFF"}
        </button>

        {/* User info + logout */}
        <div style={{ padding: "12px", borderTop: "1px solid var(--border)" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "8px 10px",
            }}
          >
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                background: "var(--accent-dim)",
                border: "1px solid var(--accent)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 11,
                fontWeight: 700,
                color: "var(--accent)",
                flexShrink: 0,
              }}
            >
              {user?.avatar}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {user?.name}
              </div>
              <div
                style={{
                  fontSize: 10,
                  color: "var(--text3)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {user?.email}
              </div>
            </div>
          </div>
          <button
            onClick={handleLogout}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "8px 10px",
              borderRadius: "var(--radius)",
              background: "transparent",
              color: "var(--danger)",
              fontSize: 12,
              fontWeight: 500,
              marginTop: 2,
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "rgba(255,77,106,0.08)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <LogOut size={14} /> Logout
          </button>
        </div>
      </aside>

      {/* ── Main content ── */}
      <main
        className="main-content"
        style={{
          flex: 1,
          overflow: "auto",
          background: "var(--bg)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Mobile Header */}
        <div
          className="menu-toggle"
          style={{
            padding: "16px",
            borderBottom: "1px solid var(--border)",
            background: "var(--surface)",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => setSidebarOpen(true)}
            style={{
              background: "none",
              border: "none",
              color: "var(--text)",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Menu size={24} />
          </button>
          <img
            src="/logo.jpeg"
            alt="WeightQA"
            onClick={() => setLogoPreview(true)}
            style={{
              marginLeft: 12,
              width: 24,
              height: 24,
              objectFit: "contain",
              cursor: "pointer",
            }}
          />
          <span style={{ marginLeft: 8, fontWeight: 600, fontSize: 16 }}>
            WeightQA
          </span>
        </div>
        <div style={{ flex: 1, overflow: "auto" }}>
          {/* <Outlet /> */}
          <Outlet
            key={role === "client" ? activeCompany?.company_id : undefined}
          />
        </div>
      </main>

      {/* ajay:code 28-07-26 */}
      {logoPreview && (
        <div
          onClick={() => setLogoPreview(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "zoom-out",
            padding: 20,
          }}
        >
          <button
            onClick={() => setLogoPreview(false)}
            style={{
              position: "fixed",
              top: 20,
              right: 20,
              width: 40,
              height: 40,
              borderRadius: "50%",
              background: "var(--surface2, #1C2030)",
              border: "1px solid var(--border2, #2E3448)",
              color: "var(--text, #E8ECF4)",
              fontSize: 20,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10000,
            }}
          >
            ✕
          </button>
          <img
            src="/logo.jpeg"
            alt="WeightQA"
            style={{
              maxWidth: "80%",
              maxHeight: "80%",
              borderRadius: 12,
              boxShadow: "0 8px 40px rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
